import React, { useState } from 'react'
import { Box, Slider, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { RangeSlider as RangeSliderType } from '../../types/sliders'
import RichText from '../RichText'

interface Props {
  slider: RangeSliderType
}

const RangeSlider: React.FC<Props> = ({ slider }) => {
  const { classes } = useStyles()
  const [sliderValue, setSliderValue] = useState<number>(slider.defaultValue)
  const handleChange = (event: any, newValue: number | number[]) => {
    setSliderValue(newValue as number)
  }

  const getLabel = (value: number, abbreviated: boolean) => {
    const sliderAmount = abbreviated
      ? `${value / 1000}k`
      : value.toLocaleString()
    return slider.label === '$'
      ? `${slider.label}${sliderAmount}`
      : `${sliderAmount} ${slider.label}`
  }
  const getMultiple = () => {
    const multiple = Math.floor(sliderValue * slider.multiple)
    return getLabel(multiple, false)
  }

  return (
    <Box className={classes.box}>
      <Slider
        classes={{ root: classes.slider, valueLabel: classes.valueLabel }}
        defaultValue={sliderValue}
        max={slider.ceiling}
        min={slider.floor}
        onChange={handleChange}
        step={slider.step}
        valueLabelDisplay="on"
        valueLabelFormat={(x) => getLabel(x, true)}
      />
      <Box className={classes.richTextBox}>
        <RichText rawBody={slider.outputText.raw} />
      </Box>
      <Typography color="primary" variant="h2" component="p">
        {getMultiple()}
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  box: {
    maxWidth: '31.75em',
    width: '90%',
  },
  richTextBox: {
    color: theme.palette.primary.main,
    padding: '2.52em 0 .69em',
  },
  slider: {
    borderLeft: '2px solid',
    borderRight: '2px solid',
    padding: '.38em 0',

    [theme.breakpoints.down('md')]: {
      width: '70%',
    },
  },
  valueLabel: {
    fontSize: '1.5rem',
    left: '50%',
    top: '50%',
    transform: 'scale(1) translate(-50%, -50%) !important',
    '& span': {
      transform: 'none',
    },
    '& > span': {
      borderRadius: '2em',
      boxShadow: '0 .25em .94em 0 rgba(34, 34, 34, 0.15)',
      height: 'auto',
      padding: '.52em 1.48em .6em',
      width: 'auto',

      [theme.breakpoints.down('md')]: {
        padding: '.25em .75em .3em',
      },
      '& > span': {
        color: theme.palette.background.default,
      },
    },
  },
}))

export default RangeSlider
